import Lightbox from './vendor/photoswipe-lightbox.esm.js';
import Psw from './vendor/photoswipe.esm.js'
function remainingCharacters(e:Event, counterElem:HTMLElement) {
  if (!counterElem) return;

  const target = e.target as HTMLInputElement;

  if (!target) return;

  // counting number of characters
  const currentLength = target.value.length;

  // updating counter value
  counterElem.innerHTML = currentLength.toString();
}

document.querySelectorAll("[data-section-type='contact-form']").forEach(container => {
  const messageElem = <HTMLInputElement>container.querySelector('[data-contact-form-message]');
  const counterElem = <HTMLElement>container.querySelector('[data-contact-form-remaining]');
  if (!messageElem || !counterElem) return;

  messageElem.addEventListener('input', (e) => {
    remainingCharacters(e, counterElem);
  });
});

const readWishlistStatus = (container:Element) => {
  const wishlistStatus = <String>container.querySelector('.wishlist-page')?.getAttribute('data-wishlist-status');
  if (wishlistStatus !== 'empty' && wishlistStatus !== 'full') return;
  const collectionListGrid = <HTMLDivElement>container.querySelector('[data-section-type="collection-list-grid"]');
  const featuredCollectionSlider = <HTMLDivElement>container.querySelector('[data-section-type="featured-collection-slider"]');
  if (collectionListGrid) {
    wishlistStatus == 'full' ? collectionListGrid.classList.add('hidden') : collectionListGrid.classList.remove('hidden');
  }
  
  if (featuredCollectionSlider) {
    wishlistStatus == 'full' ? featuredCollectionSlider.classList.add('hidden') : featuredCollectionSlider.classList.remove('hidden');
  }
}

document.querySelectorAll("[data-wishlist-page='data-wishlist-page']").forEach((container) => {
  const config = { childList: true, subtree: true };
  
  const callback = (mutationList:Array<MutationRecord>, observer:MutationObserver) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        readWishlistStatus(container);
      }
    }
  }
  
  const observer = new MutationObserver(callback);
  
  observer.observe(container, config);
});

// @ts-ignore
var icons$1 = window?.theme?.icons;

const lightbox = new Lightbox({
  gallery: ".lightbox-media-container",
      children: ".lightbox-image",
      mainClass: "pswp--product-lightbox",
      bgOpacity: 1,
      arrowPrevSVG: icons$1.chevron,
      arrowNextSVG: icons$1.chevron,
      closeSVG: icons$1.close,
      zoomSVG: icons$1.zoom,
      pswpModule: Psw
});
lightbox.init();

// remove the class "pointer-events-none" from the elements with the class "lightbox-image"
document.querySelectorAll(".lightbox-image").forEach((elem) => {
  elem.classList.remove("pointer-events-none");
}); 